import React from 'react'

function ForgotPasswordPage() {
  return (
    <div>ForgotPasswordPage</div>
  )
}

export default ForgotPasswordPage